<template>
    <div class="data_select">
            <div class="data_select_box" v-for="(item,index) in options" :key="index">
                <div class="data_select_ensure">
                    <div class="title" :style="'width:' + (item.answer_cnt/done_cnt*100) + '%;'">
                      <div class="bg">
                        {{item.title}}
                      </div>
                    </div>
                </div>
                <div class="data_select_text">
                    {{item.answer_cnt}}人&nbsp;
                    {{isNaN((item.answer_cnt/done_cnt*100).toFixed(2)) ? 0:(item.answer_cnt/done_cnt*100).toFixed(2)}}%
                </div>
            </div>
            <div class="problem">
                <div class="problem_title">{{index + 1}}. {{title}}</div>
                <van-image
                  width="100%"
                  height="100%"
                  v-if="img_url !== ''"
                  :src="img_url"
                />
            </div>
    </div>
</template>

<script>
import numberToLetter from '../../../../utils/NumberToLetter'
export default {
  props: {
    title: {
      type: String
    },
    options: {
      type: Array
    },
    question_id: {
      type: Number
    },
    done_cnt: {
      type: Number
    },
    index: {
      type: Number
    },
    survey_total_cnt: {
      type: Number
    },
    dep_result: {
      type: Array
    },
    img_url: {
      type: String
    }
  },
  methods: {
    setNumberToLetter (num) {
      return numberToLetter(num)
    }
  }
}
</script>

<style lang='scss' scoped>
.data_select{
        background: #fff;
        width: 91.47%;
        margin: 10px auto;
        padding: 5px 0;
        border-radius: 12px;
        .data_select_box{
            margin: 10px auto;
            width: 91.47%;
            height: 30px;
            line-height: 30px;
            display: flex;
            justify-content: space-between;
            background-color: #e7edf5;
            border-radius: 6px;
            position: relative;
            .data_select_ensure{
                width: 100%;
                border-radius: 6px;
                .title{
                  position:relative;
                  background-color:#19cca0;
                  border-radius: 6px;
                  height: 100%;
                  // margin-left: 15px;
                  // z-index: 999;
                  .bg{
                    position:absolute;
                    left: 15px;
                    top: 0;
                    height: 100%;
                    width: 300px;
                  }
                }
            }
            .data_select_text{
                position: absolute;
                margin-left: 60%;
                width: 40%;
                text-align: end;
            }
        }
        .problem{
            width: 91.47%;
            margin: 10px auto;
            .problem_title{
                font-weight: 500;
                margin-bottom: 5px;
            }
            .proble_select{
                margin: 2px 0;
                font-size: 14px;
            }
        }
    }
</style>
